import { Route } from "react-router-dom";
import Reservation from "./Reservation";
import ListReservation from "./ListReservation";
import AddReservation from "./AddReservation";
import UpdateReservation from "./UpdateReservation";

export default (
  <Route path="Reservation" exact element={<Reservation />}>
    <Route index element={<ListReservation />} />
    <Route path="add/:cid" element={<AddReservation />} />
    <Route path="edit/:cid/:id" element={<UpdateReservation />} />
  </Route>
);
